"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaConteneurAmarrable = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _utilitaires = require("../utils/utilitaires");

var _utilitaires2 = require("../utils/utilitaires.elements");

require("../css/mfa-conteneuramarrable.css");

var _MfaBouton = require("./MfaBouton");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaConteneurAmarrable = /*#__PURE__*/function (_Component) {
  _inherits(MfaConteneurAmarrable, _Component);

  var _super = _createSuper(MfaConteneurAmarrable);

  function MfaConteneurAmarrable(props) {
    var _this;

    _classCallCheck(this, MfaConteneurAmarrable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "evennementCorps", void 0);

    _defineProperty(_assertThisInitialized(_this), "evennementCorpsSourisRelachee", void 0);

    _defineProperty(_assertThisInitialized(_this), "xInitial", 30);

    _defineProperty(_assertThisInitialized(_this), "yInitial", -30);

    _defineProperty(_assertThisInitialized(_this), "element", void 0);

    _this.evennementCorps = function (evennement) {
      var _this$state = _this.state,
          amarre = _this$state.amarre,
          enMouvement = _this$state.enMouvement,
          fixe = _this$state.fixe;

      if (amarre === true || enMouvement === false || fixe === true) {
        return;
      }

      var positionSouris = _this.obtenirPositionSouris(evennement);

      _this.mettreAJourPosition(positionSouris.x, positionSouris.y);
    };

    _this.evennementCorpsSourisRelachee = function (evennement) {
      _this.mettreEnMouvement(evennement, false);

      document.body.removeEventListener('mouseup', _this.evennementCorpsSourisRelachee);
    };

    _this.state = {
      amarre: true,
      differenceInitiale: null,
      positionX: 0,
      positionY: 0,
      enMouvement: false,
      fixe: false
    };
    return _this;
  }

  _createClass(MfaConteneurAmarrable, [{
    key: "obtenirPositionSouris",
    value: function obtenirPositionSouris(evennement) {
      var pageX = evennement.pageX,
          pageY = evennement.pageY;
      return {
        x: pageX,
        y: pageY
      };
    }
  }, {
    key: "mettreAJourPosition",
    value: function mettreAJourPosition(sourisX, sourisY) {
      if (!(0, _utilitaires.estDefini)(this.element)) {
        return;
      }

      var differenceInitiale = this.state.differenceInitiale;
      var _document = document,
          documentElement = _document.documentElement;
      var parentRelatif = (0, _utilitaires2.premierParentRelatif)(this.element);
      var gaucheParent = (0, _utilitaires2.gauche)(parentRelatif);
      var topParent = (0, _utilitaires2.top)(parentRelatif);
      this.setState({
        positionX: sourisX + differenceInitiale.x - gaucheParent - documentElement.scrollLeft,
        positionY: sourisY + differenceInitiale.y - topParent - documentElement.scrollTop
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('mousemove', this.evennementCorps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('mousemove', this.evennementCorps);
    }
  }, {
    key: "obtenirBoutonEntete",
    value: function obtenirBoutonEntete(nomIcone, surClique) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: nomIcone,
        className: "mfa-conteneuramarrable-boutonentete"
      }, /*#__PURE__*/_react.default.createElement("a", {
        onMouseDown: function onMouseDown(evennement) {
          return evennement.stopPropagation();
        },
        onClick: function onClick(evennement) {
          evennement.stopPropagation();

          if (!(0, _utilitaires.estDefini)(surClique)) {
            return;
          }

          surClique(evennement);
        }
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: nomIcone
      })));
    }
  }, {
    key: "mettreEnMouvement",
    value: function mettreEnMouvement(evennement, enMouvement) {
      var amarre = this.state.amarre;

      if (amarre === true) {
        return;
      }

      var differenceInitiale = this.obtenirDifferenceInitiale(evennement);

      if (enMouvement === true) {
        document.body.addEventListener('mouseup', this.evennementCorpsSourisRelachee);
      }

      this.setState({
        enMouvement: enMouvement,
        differenceInitiale: enMouvement ? differenceInitiale : null
      });
    }
  }, {
    key: "obtenirDifferenceInitiale",
    value: function obtenirDifferenceInitiale(evennement) {
      var positionSouris = this.obtenirPositionSouris(evennement);
      var distanceX = (0, _utilitaires2.distanceHorizontale)(this.element, document.body);
      var distanceY = (0, _utilitaires2.distanceVerticale)(this.element, document.body);
      return {
        x: distanceX - positionSouris.x,
        y: distanceY - positionSouris.y
      };
    }
  }, {
    key: "obtenirPositionInitale",
    value: function obtenirPositionInitale() {
      var gaucheElement = (0, _utilitaires2.gauche)(this.element);
      var topElement = (0, _utilitaires2.top)(this.element);
      var parentRelatif = (0, _utilitaires2.premierParentRelatif)(this.element);
      var gaucheParent = (0, _utilitaires.estDefini)(parentRelatif) ? (0, _utilitaires2.gauche)(parentRelatif) : 0;
      var topParent = (0, _utilitaires.estDefini)(parentRelatif) ? (0, _utilitaires2.top)(parentRelatif) : 0;
      return {
        x: this.xInitial + gaucheElement - gaucheParent,
        y: this.yInitial + topElement - topParent
      };
    }
  }, {
    key: "desancrer",
    value: function desancrer(differenceInitiale) {
      var positionInitiale = this.obtenirPositionInitale();
      this.setState({
        differenceInitiale: differenceInitiale,
        amarre: false,
        positionX: positionInitiale.x,
        positionY: positionInitiale.y
      });
    }
  }, {
    key: "ancrer",
    value: function ancrer() {
      this.setState({
        enMouvement: false,
        differenceInitiale: false,
        amarre: true,
        fixe: false
      });
    }
  }, {
    key: "fixer",
    value: function fixer() {
      var gaucheElement = (0, _utilitaires2.gauche)(this.element);
      var topElement = (0, _utilitaires2.top)(this.element);
      var fixe = this.state.fixe;
      var parentRelatif = (0, _utilitaires2.premierParentRelatif)(this.element);
      var gaucheParent = fixe && (0, _utilitaires.estDefini)(parentRelatif) ? (0, _utilitaires2.gauche)(parentRelatif) : 0;
      var topParent = fixe && (0, _utilitaires.estDefini)(parentRelatif) ? (0, _utilitaires2.top)(parentRelatif) : 0;
      this.setState({
        fixe: !fixe,
        enMouvement: false,
        positionX: gaucheElement - gaucheParent,
        positionY: topElement - topParent
      });
    }
  }, {
    key: "renderBoutons",
    value: function renderBoutons() {
      var _this2 = this;

      var amarre = this.state.amarre;

      if (amarre === true) {
        return this.obtenirBoutonEntete('share', function (evennement) {
          var differenceInitiale = _this2.obtenirDifferenceInitiale(evennement);

          _this2.desancrer(differenceInitiale);
        });
      }

      return [this.obtenirBoutonEntete('level down alternate', function () {
        return _this2.ancrer();
      }), this.obtenirBoutonEntete('thumbtack', function () {
        return _this2.fixer();
      })];
    }
  }, {
    key: "renderEntete",
    value: function renderEntete() {
      var _this3 = this;

      var afficherEntenteAmarre = this.props.afficherEntenteAmarre;
      var amarre = this.state.amarre;

      if (amarre === true && afficherEntenteAmarre === false) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        onMouseDown: function onMouseDown(evennement) {
          return _this3.mettreEnMouvement(evennement, true);
        },
        className: "mfa-conteneuramarrable-entete"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-conteneuramarrable-entete-barreboutons"
      }, this.renderBoutons()));
    }
  }, {
    key: "obtenirStyle",
    value: function obtenirStyle() {
      var _this$state2 = this.state,
          amarre = _this$state2.amarre,
          positionX = _this$state2.positionX,
          positionY = _this$state2.positionY,
          fixe = _this$state2.fixe;

      if (amarre === true) {
        return null;
      }

      var style = {
        left: "".concat(positionX, "px"),
        top: "".concat(positionY, "px")
      };

      if (fixe === true) {
        style.position = 'fixed';
      }

      return style;
    }
  }, {
    key: "renderBoutonAncrer",
    value: function renderBoutonAncrer() {
      var _this4 = this;

      var amarre = this.state.amarre;
      var messageRetourner = this.props.messageRetourner;

      if (amarre === true) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        onClick: function onClick() {
          return _this4.ancrer();
        }
      }, (0, _utilitaires.estDefini)(messageRetourner) ? messageRetourner : 'Retourner contenu');
    }
  }, {
    key: "renderContenu",
    value: function renderContenu() {
      if (this.aucunEnfants()) {
        return this.renderVide();
      }

      return this.renderCorps();
    }
  }, {
    key: "renderCorps",
    value: function renderCorps() {
      var _this5 = this;

      var _this$state3 = this.state,
          amarre = _this$state3.amarre,
          fixe = _this$state3.fixe;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        style: this.obtenirStyle(),
        ref: function ref(_ref) {
          return (0, _utilitaires.enregistrerSiDefini)(_this5, 'element', _ref);
        },
        className: "mfa-conteneuramarrable".concat(amarre === false ? ' libre' : '').concat(fixe === true ? ' fixe' : '')
      }, this.renderEntete(), /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-conteneuramarrable-contenu"
      }, this.props.children)), this.renderBoutonAncrer());
    }
  }, {
    key: "renderVide",
    value: function renderVide() {
      return 'Aucun contenu.';
    }
  }, {
    key: "aucunEnfants",
    value: function aucunEnfants() {
      var children = this.props.children;

      if (!(0, _utilitaires.estDefini)(children) || children instanceof Array && children.length === 0) {
        return true;
      }

      return false;
    }
  }, {
    key: "estVide",
    value: function estVide() {
      var amarre = this.state.amarre;
      return this.aucunEnfants() || amarre === false;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-conteneuramarrable-ancre".concat(this.estVide() === true ? ' vide' : '')
      }, this.renderContenu());
    }
  }]);

  return MfaConteneurAmarrable;
}(_react.Component);

exports.MfaConteneurAmarrable = MfaConteneurAmarrable;